
<ng-container *ngIf="shouldDisplay">
  <div id="failed-sync-notification" class="alert alert-warning">
    <small>
      <fa-icon [icon]="['fas', 'info-circle']" class="mr-2"></fa-icon><span [innerHTML]="'module_sync_error_occured' | translate"></span>
    </small>
  </div>
</ng-container>
